// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1o68G","content":"RecentSearches_content__1aJBd"};